// Maps an old oa-ui path under /aqua/orders or /aqua/line-items to its equivalent
// path in aqua-ui, which uses the same shape without the /aqua prefix, except the
// create route is named "new" instead of "create". Old sub-tab paths (e.g. an
// order's history tab) have no aqua-ui equivalent, so they land on the object's
// base detail page rather than 404ing.
export function buildAquaUiRedirectPath(pathname: string): string {
  const match = pathname.match(/^\/aqua\/(orders|line-items)(\/.*)?$/);

  if (!match) {
    // Bare /aqua index previously rendered the Orders list.
    return '/direct/orders';
  }

  const [, resource, rest = ''] = match;
  const segments = rest.split('/').filter(Boolean);

  if (segments.length === 0) {
    return `/direct/${resource}`;
  }

  if (segments[0] === 'create') {
    return `/direct/${resource}/new`;
  }

  const [id, action] = segments;
  return action === 'edit' ? `/direct/${resource}/${id}/edit` : `/direct/${resource}/${id}`;
}
